import { motion, Variants } from "motion/react";
import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { greyMui, rydeColors, ScreenDepth } from "@ryde/theme";

export const helpTopicDrawerMotionVariants: Variants = {
  initial: width => ({
    x: `calc(-1 * ${width})`,
  }),
  animation: {
    x: 0,
    transition: { type: "tween", duration: 0.38, ease: "easeOut" },
  },
  exit: width => ({
    x: `calc(-1 * ${width})`,
    transition: { type: "tween", duration: 0.28, ease: "easeIn" },
  }),
};

export const HelpTopicDrawerBackdropStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "help-topic-drawer-backdrop",
  },
)`
  position: fixed;
  inset: 0;
  z-index: ${ScreenDepth.MENU_DRAWER_BACKDROP};
  background-color: rgb(15 23 42 / 0.38);
  backdrop-filter: blur(1px);
`;

export const HelpTopicDrawerPanelStyled = styled(motion.div).attrs<
  IStyledAttributes & { customWidth: string }
>(props => ({
  [DATA_E2E_KEY]: "help-topic-drawer-panel",
  custom: props.customWidth,
}))<{ customWidth: string }>`
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline-start: 0;
  width: ${({ customWidth }) => customWidth};
  max-width: min(92vw, ${({ customWidth }) => customWidth});
  background: ${rydeColors.white};
  border-inline-end: 1px solid ${greyMui._200};
  box-shadow: 8px 0 32px rgb(15 23 42 / 0.14);
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .HelpTopicDrawer-Loading,
  .HelpTopicDrawer-Error {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 120px;
    padding: 24px;
    color: ${greyMui._600};
  }

  .help-topic-drawer-content {
    padding: 20px 24px 28px;
    overflow: auto;
  }
`;

export const HelpTopicDrawerHeaderStyled = styled.header.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "help-topic-drawer-header",
  },
)`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 12px 14px 20px;
  border-bottom: 1px solid ${greyMui._200};
  background: linear-gradient(
    180deg,
    ${greyMui._50} 0%,
    ${rydeColors.white} 100%
  );
`;

export const HelpTopicDrawerTitleStyled = styled.h2`
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
  color: ${greyMui._800};
  line-height: 1.3;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const HelpTopicDrawerToolbarStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
`;
